import { render, staticRenderFns } from "./_4.vue?vue&type=template&id=22ea3a87&scoped=true&"
import script from "./_4.vue?vue&type=script&lang=js&"
export * from "./_4.vue?vue&type=script&lang=js&"
import style0 from "./_4.vue?vue&type=style&index=0&id=22ea3a87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ea3a87",
  null
  
)

export default component.exports